import { config } from 'configuration';
import { RichTextRenderer, Space, Title } from 'ui';

const PrivacyPolicy = () => (
  <Space className="privacy-policy" orientation="vertical" size="xl">
    <Title level={1} marginBottom>
      Privacy Policy
    </Title>
    <div className="privacy-policy__content">
      <RichTextRenderer data={config.privacyPolicy.htmlContent} />
    </div>
  </Space>
);

export default PrivacyPolicy;
